<template>
    <div>
          <div v-for="(taxa, key) in lista_taxas" :key="key">

         <label v-if="taxas.includes(taxa.id)">
              <span class="font-bold"> {{ taxa.label }}</span>
              <br />

                <span class="font-bold">{{    viabilidade.taxas[taxa.id].tipo_cobranca !=
                  'trimestral_recorrente' ? "Vencimento:" : "Primeiro vencimento" }}</span>
              {{ formatEnToBr(viabilidade.taxas[taxa.id].valor) }}
              <div
                v-if="
                  viabilidade.taxas[taxa.id].tipo_cobranca ==
                  'trimestral_recorrente'
                "
              >
                <span class="font-bold">{{ "Segundo vencimento:" }}</span>
                {{ formatEnToBr(viabilidade.taxas[taxa.id].valor1) }}
                <br />
                <span class="font-bold">{{ "Terceito vencimento:" }}</span>
                {{ formatEnToBr(viabilidade.taxas[taxa.id].valor2) }}
              </div>
              <br v-else/>
              <span class="font-bold">{{ "Observação:" }}</span>
              {{ viabilidade.taxas[taxa.id].observacao }}
              <br />
              <span class="font-bold">{{ "Tipo de Cobrança:" }}</span>
               {{
                lista_tipo_cobrancas.find(
                  (item) => item.id == viabilidade.taxas[taxa.id].tipo_cobranca
                ).label
              }}
              <br />
              <span class="font-bold">{{ "Tipo de taxa:" }}</span>
                <span v-if="viabilidade.taxas[taxa.id].tipo_taxa"
                >{{
                  taxasOptions.find(
                    (item) => item.value == viabilidade.taxas[taxa.id].tipo_taxa
                  ).label
                }}
              </span>
              <span v-else class="bg-error-base rounded-full p-1">
                Sem tipo da taxa
              </span>
              <hr style="border: 2px black solid" class="mt-2 mb-2" />
            </label>
          </div>
    </div>
</template>
<script>
import { TipoTaxasEnum } from "@/utils/enum";
import moment from "moment";
 
export default {
  props: {
    taxas: {
      type: Array,
      required: true,
    },

    viabilidade: {
      type: Object,
      required: true,
    },
  },
  created(){
    console.log(this.viabilidade)
  },
  data() {
    return {
      taxasOptions: TipoTaxasEnum,
       lista_taxas: [
       {
          id: "alvara",
          label: "Alvara",
        },
        {
          id: "sanitario",
          label: "Sanitario",
        },
        {
          id: "bombeiro",
          label: "Bombeiro",
        },
        {
          id: "ambiental",
          label: "Ambiental",
        },
      ],
      lista_tipo_cobrancas: [
        {
          id: "mensal",
          label: "Mensal",
        },
        {
          id: "trimestral",
          label: "Trimestral",
        },
        {
          id: "trimestral_recorrente",
          label: "Trimestral recorrente",
        },
        {
          id: "semestral",
          label: "Semestral",
        },
        {
          id: "anual",
          label: "Anual",
        },
      ],
    };
  },
  methods: {
    formatEnToBr(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>

